<script>
    let possibale;
    let majority;
    let ramp;
    let strikes;
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    import {onMount} from 'svelte';
    // eslint-disable-next-line require-jsdoc
    function mover() {
        possibale.style.right='75vw';
        majority.style.right='50vw';
        ramp.style.right='25vw';
        strikes.style.right='0vw';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(mover, 10);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            goto('/future');
        }
        if (e.key == 'ArrowLeft') {
            goto('/mission');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>

<section role = 'presentation' on:click={()=> goto('/future')}>
    <div class="possibale" bind:this={possibale}>
        <div class="text">
            <h1>
                Possible <br /> Outcomes <br />
                in the
            </h1>
            <h1>next</h1>
            <h1>5 <span>years</span></h1>
        </div>
    </div>
    <div class="majority" bind:this={majority}>
        <div class="imgWrraper">
            <img
                src="/images/outcomes/men.png"
                alt="images"
                height="100%"
                width="100%"
                class = "img"
            />
        </div>
        <div class="text">
            <h1>We win and become a majority gaming platform</h1>
            <p>
                500M+ users
                <br />
                5,000x returns
            </p>
        </div>
    </div>
    <div class="ramp" bind:this={ramp}>
        <div class="imgWrraper">
            <img
                src="/images/outcomes/robot.png"
                alt="images"
                height="100%"
                width="100%"
                class = "img"
            />
        </div>
        <div class="text">
            <h1>We take 5+ years to ramp up</h1>
            <p>Bigger players heavily invest in generative AI and catch up.</p>
            <p>
                We remain a small gaming platform. <br />
                <span>(50M+ users)</span>
            </p>
            <p>
                We pivot to enterprise, robotics and Gov contracts for
                simulation.
            </p>
            <p>500x returns</p>
        </div>
    </div>
    <div class="strikes" bind:this={strikes}>
        <div class="imgWrraper">
            <img
                src="/images/outcomes/nature.png"
                alt="images"
                height="100%"
                width="100%"
                class = "img"
            />
        </div>
        <div class="text">
            <h1>DISASTER STRIKES</h1>
            <p>
                Earth gets destroyed by a metroid and we have to retreat to an
                underground bunker.
            </p>
            <p>
                It takes 20+ years but we rebuild earth using trained knowledge
                and robots.
            </p>
            <p>10,000,000x returns</p>
        </div>
    </div>
</section>

<style>
    section {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        background-color: #030618; 
    }
    .possibale {
        right: -25vw;
        width: 25vw;
        height: 100vh;
        position: absolute;
        transition-duration:0.4s;
        background-color: #ff007f;
    }
    .possibale .text {
        left: 2vw;
        bottom: 2vh;
        position: absolute;
    }
    .possibale .text h1 {
        margin: 0;
        color: #010422;
        font-style: normal;
        text-transform: uppercase;
        font-family: "Montserrat";
    }
    .possibale .text h1:nth-child(1) {
        font-weight: 900;
        font-size: 2.083vw;
        line-height: 95.5%;
    }
    .possibale .text h1:nth-child(2) {
        line-height: 85%;
        font-weight: 900;
        font-size: 3.125vw;
    }
    .possibale .text h1:nth-child(3) {
        font-weight: 900;
        line-height: 78.9%;
        font-size: 10.417vw;
    }
    .possibale .text h1:nth-child(3) span {
        font-weight: 900;
        margin-left: -3vw;
        line-height: 78.9%;
        font-size: 4.167vw;
    }
    .majority {
        top: 0vh;
        right: -25vw;
        width: 25vw;
        height: 100vh;
        font-style: normal;
        position: absolute;
        font-family: "Montserrat";
        transition-duration:0.4s;
        background-color: rgb(44, 1, 1);
    }
    .majority .text {
        position: absolute;
        color: #ffffff;
        height: 100%;
        width: 100%;
        top: 0vh;
    }
    .majority .text h1 {
        width: 21vw;
        margin: auto 2vw;
        font-weight: 900;
        line-height: 85%;
        font-size: 2.083vw;
        text-transform: uppercase;
        position: absolute;
        top: 5.648vh;
    }
    .majority .text p {
        font-weight: 700;
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 10.463vh;
    }
    .ramp {
        top: 0vh;
        right: -25vw;
        width: 25vw;
        height: 100vh;
        font-style: normal;
        position: absolute;
        font-family: "Montserrat";
        transition-duration:0.4s;
        background-color: rgb(44, 1, 1);
    }
    .ramp .text {
        position: absolute;
        color: #ffffff;
        height: 100%;
        width: 100%;
        top: 0vh;
    }
    .ramp .text h1 {
        width: 25vw;
        margin: auto 2vw;
        font-weight: 900;
        line-height: 85%;
        font-size: 2.083vw;
        text-transform: uppercase;
        position: absolute;
        top: 5.648vh;
    }
    .ramp .text p:nth-child(2) {
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 37.963vh;
        line-height: 2.6vh;
    }
    .ramp .text p:nth-child(3) {
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 25.093vh;
        line-height: 2.6vh;
    }
    .ramp .text p:nth-child(3) span {
        line-height: 6vh;
    }
    .ramp .text p:nth-child(4) {
        margin: auto 2vw;
        bottom: 16.111vh;
        font-size: 1.563vw;
        position: absolute;
        line-height: 2.6vh;
    }
    .ramp .text p:nth-child(5) {
        font-weight: 700;
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 10.463vh;
    }
    .strikes {
        top: 0vh;
        right: -25vw;
        width: 25vw;
        height: 100vh;
        font-style: normal;
        position: absolute;
        font-family: "Montserrat";
        transition-duration:0.4s;
        background-color: rgb(0, 0, 0);
    }
    .strikes .text {
        position: absolute;
        color: #ffffff;
        height: 100%;
        width: 100%;
        top: 0vh;
    }
    .strikes .text h1 {
        width: 21vw;
        margin: auto 2vw;
        font-weight: 900;
        line-height: 85%;
        font-size: 2.083vw;
        text-transform: uppercase;
        position: absolute;
        top: 5.648vh;
    }
    .strikes .text p:nth-child(2) {
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 25.093vh;
        line-height: 2.6vh;
    }
    .strikes .text p:nth-child(3) {
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 16.111vh;
        line-height: 2.6vh;
    }
    .strikes .text p:nth-child(4) {
        font-weight: 700;
        margin: auto 2vw;
        font-size: 1.563vw;
        position: absolute;
        bottom: 10.463vh;
    }
    .imgWrraper {
        height: 100vh;
    }
    .img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
</style>
